import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Navigation, MapPin } from 'lucide-react'; // Add icons import

const CampusSelection1 = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleCampusSelect = (isSouth) => {
    localStorage.setItem('selectedCampus', isSouth ? 'south' : 'north');
    navigate('/checkout', { 
      state: {
        ...location.state,  // Pass through all state from OfferMenu
        selectedCampus: isSouth ? 'south' : 'north'
      }
    });
  };

  return (
    <div className="bg-black min-h-screen flex flex-col">
      {/* Enhanced background with animated gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(74,222,128,0.03)_0%,transparent_70%)]" />
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[linear-gradient(45deg,#242424_1px,transparent_1px),linear-gradient(-45deg,#111111_1px,transparent_1px)] bg-[length:20px_20px] opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-green-900/20 to-transparent" />
      </div>

           {/* Background patterns */}
           <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[linear-gradient(45deg,#242_1px,transparent_1px),linear-gradient(-45deg,#111_1px,transparent_1px)] bg-[size:20px_20px]" />
        <div className="absolute inset-0 bg-[linear-gradient(0deg,#222_1px,transparent_1px),linear-gradient(90deg,#111_1px,transparent_1px)] bg-[size:40px_40px] opacity-50" />
      </div>
      

      {/* Title at the top with slide animation */}
      <div className="absolute left-5 text-center pt-4 animate-slide-in-left" 
           style={{ 
             animation: 'slideInFromLeft 0.8s ease-out forwards',
             opacity: 0,
           }}>
        <div className="flex items-center justify-center gap-3">
          <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" />
          <h1 className="text-2xl md:text-3xl font-mono text-white">
            <span className="text-green-400 animate-pulse">|</span> SELECT-YOUR-CAMPUS /
          </h1>
        </div>
        <p className="text-green-400/60 text-xs md:text-sm font-mono mt-1">
          to discover nearby restaurants
        </p>
      </div>

      {/* Main Content Container with Offset Centering */}
      <div className="flex-1 flex items-center justify-center">
        <div className="absolute bottom-50 max-w-sm w-full mx-auto px-16 -mt-16"> {/* Negative margin to shift up */}
          <div className="grid grid-cols-1 gap-20 w-full"> {/* Increased gap from 8 to 16 */}
            
            {/* North Campus Card */}
            <button
              onClick={() => handleCampusSelect(false)}
              className="group relative flex items-center justify-center bg-green-400 text-black px-4 py-2 
                       hover:bg-green-500 active:bg-green-600 
                       transition-colors"
            >
              {/* Edge Patterns */}
              <div className="absolute -inset-[1px] border border-white/50" />
              <div className="absolute -inset-[2px] border border-white/30" />
              <div className="absolute -inset-[3px] border border-white/10" />
              
              {/* Corner Decorations */}
              <div className="absolute -top-1 -left-1 w-2 h-2 border-t border-l border-white/50" />
              <div className="absolute -top-1 -right-1 w-2 h-2 border-t border-r border-white/50" />
              <div className="absolute -bottom-1 -left-1 w-2 h-2 border-b border-l border-white/50" />
              <div className="absolute -bottom-1 -right-1 w-2 h-2 border-b border-r border-white/50" />
              
              <Navigation className="mr-2 h-4 w-4" /> NORTH_CAMPUS
            </button>

            {/* South Campus Card */}
            <button
              onClick={() => handleCampusSelect(true)}
              className="group relative flex items-center justify-center bg-green-400 text-black px-4 py-2 
                       hover:bg-green-500 active:bg-green-600 
                       transition-colors"
            >
              {/* Edge Patterns */}
              <div className="absolute -inset-[1px] border border-white/50" />
              <div className="absolute -inset-[2px] border border-white/30" />
              <div className="absolute -inset-[3px] border border-white/10" />
              
              {/* Corner Decorations */}
              <div className="absolute -top-1 -left-1 w-2 h-2 border-t border-l border-white/50" />
              <div className="absolute -top-1 -right-1 w-2 h-2 border-t border-r border-white/50" />
              <div className="absolute -bottom-1 -left-1 w-2 h-2 border-b border-l border-white/50" />
              <div className="absolute -bottom-1 -right-1 w-2 h-2 border-b border-r border-white/50" />
              
              <MapPin className="mr-2 h-4 w-4" /> SOUTH_CAMPUS
            </button>
          </div>
        </div>
      </div>

      {/* Add keyframes for the slide animation */}
      <style jsx>{`
        @keyframes slideInFromLeft {
          0% {
            transform: translateX(-100%);
            opacity: 0;
          }
          100% {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default CampusSelection1;